import { type FC, memo, useState } from 'react';
import styles from './wallet-connected.module.scss';
import downIcon from '@assets/images/header/down.svg';
import { useToggle } from 'react-use';

import { useCurrentAccount, useCurrentWallet, useResolveSuiNSName } from '@mysten/dapp-kit';
import WalletList from './wallet-list';
import { formatAddress } from '@mysten/sui/utils';

import { OpenapiClientParrot } from 'src/openapi/parrot';

import Popover from '@ui/parrot/popover';

const WalletConnected: FC = () => {
  // const address = useAddress();
  const currentAccount = useCurrentAccount();
  const wallet = useCurrentWallet();
  const suiNames = useResolveSuiNSName(currentAccount?.address);
  const [showMenu, toggleShowMenu] = useToggle(false);

  const [user, setUser] = useState<OpenapiClientParrot.GetUsersByWalletResponse>();

  return (
    <Popover
      content={<WalletList toggleShowMenu={toggleShowMenu} changeUser={setUser} />}
      trigger={'click'}
      open={showMenu}
      onOpenChange={toggleShowMenu}
    >
      <div className={`${styles.button} ${showMenu ? styles.active : ''}`} key="connected">
        <img src={user?.avatar || wallet.currentWallet?.icon} className={styles.wallet_icon} />
        <span>
          {user?.username
            ? user.username
            : suiNames.data
            ? suiNames.data
            : currentAccount?.address
            ? formatAddress(currentAccount.address)
            : ''}
        </span>
        <img src={downIcon} className={styles.arrow_icon} />
      </div>
    </Popover>
  );
};

export default memo(WalletConnected);
